// import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'
// import {vendorSaga} from './saga/vendorSaga'
import {modalLoadingReducer} from './reducers/modalLoadingReducer'
import {productReducer} from './reducers/productReducer'
import repositoryReducer from './reducers/repositoryReducer'
import * as auth from './reducers/authReducer'
import {transferCartReducer} from './reducers/cartReducer'
import {transferProductReducer} from './reducers/transferProductReducer'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  product: productReducer,
  transferProduct: transferProductReducer,
  modalLoading: modalLoadingReducer,
  repository: repositoryReducer,
  transferCart: transferCartReducer,
})

// export function* rootSaga() {
//   yield all([vendorSaga()])
// }
